import { useAppSelector } from '../../redux';
import { CompanyInfo, companyInfoSelector, currentCompanySelector } from '../../redux/company';

export const DUMMY_COMPANY_INFO: CompanyInfo = {
  agency: '',
  cid: '',
  experiments: [],
  groups: [],
  initial_kpi: '',
  kpi_filter_order: [],
  kpis: [],
  name: '',
  streaming_performance_default_kpi: '',
  streaming_performance_default_lag: '1d',
  cross_channel_kpis: [],
  custom_dashboards: [],
  fiscal_cal: {},
  salesforce_ids: [],
  currency_code: ''
};

export const useCompanyInfo: (inputCompany?: string) => CompanyInfo = (inputCompany?: string) => {
  const currentCompany = useAppSelector(currentCompanySelector);
  const company = inputCompany ?? currentCompany;
  const companyInfo = useAppSelector(companyInfoSelector(company));
  return companyInfo || DUMMY_COMPANY_INFO;
};
